import { productQueryKeys } from 'src/query-keys'
import { ICreateProduct, IProduct } from '../generated-types'
import { queryClient } from '../query-client'
import { apiConsts } from './apiConsts'
import { IPaginatedResult } from './paginated-result'
import { useDelete, useGet, usePost, usePut } from './reactQuery'

const baseUrl = () => 'admin/products'
const baseBySupplierIdUrl = (supplierId: EntityId) => `admin/products/GetBySupplierId/${supplierId}`

export const productsEndpoints = {
  getProducts() {
    return `${baseUrl()}`
  },
  getProduct(id: EntityId) {
    return `${baseUrl()}/${id}`
  },
  getProductsBySupplierId(supplierId: EntityId) {
    return `${baseBySupplierIdUrl(supplierId)}`
  },
  getServiceProductsForSupplier(supplierId: EntityId) {
    return `${baseUrl()}/get-service-products-for-supplier/${supplierId}`
  },
  createProduct() {
    return `${baseUrl()}`
  },
  updateProduct(id: EntityId) {
    return `${baseUrl()}/${id}`
  },
  deleteProduct() {
    return `${baseUrl()}`
  },
}

export const invalidateProductCache = {
  getProducts(searchInput?: string, page: number = apiConsts.Page, pageSize: number = apiConsts.PageSize) {
    queryClient.invalidateQueries(productQueryKeys.GET_PRODUCTS(searchInput))
  },
  getProduct(id: EntityId) {
    queryClient.invalidateQueries(productsEndpoints.getProduct(id))
  },
}

export const useGetProducts = (
  searchInput?: string,
  page: number = apiConsts.Page,
  pageSize: number = apiConsts.PageSize,
  options?: object,
) =>
  useGet<IPaginatedResult<IProduct>>(
    productsEndpoints.getProducts(),
    { page, pageSize, searchInput },
    { queryKey: productQueryKeys.GET_PRODUCTS(searchInput), ...options },
  )

export const useGetProduct = (id: EntityId) => useGet<IProduct>(productsEndpoints.getProduct(id))

export const useAddProduct = () => usePost<IProduct, ICreateProduct>(productsEndpoints.createProduct())

export const useGetProductsBySupplierId = (
  supplierId: EntityId,
  page: number = apiConsts.Page,
  pageSize: number = apiConsts.PageSize,
) => useGet<IPaginatedResult<IProduct>>(productsEndpoints.getProductsBySupplierId(supplierId), { page, pageSize })

export const useUpdateProduct = (id: EntityId) => usePut<IProduct, IProduct>(productsEndpoints.updateProduct(id))

export const useDeleteProduct = () => useDelete<IProduct>(productsEndpoints.deleteProduct())

export const useGetServiceProductsForSupplier = (supplierId: EntityId) => {
  return useGet<IProduct[]>(
    productsEndpoints.getServiceProductsForSupplier(supplierId),
    {},
    {
      enabled: !!supplierId && supplierId !== 0,
    },
  )
}
